import * as React from "react";
import { Typography } from "antd";
import DisplayForm from "../../form/DisplayForm";
import { IFormSectionPresentationModel } from "../../../../presenter/form/model/FormSectionPresentationModel";

const Report1Preview = ({
  translate,
  title,
  data,
  subtitle,
  loader,
  isPortal = false
}: {
  translate?: any;
  data?: IFormSectionPresentationModel[];
  title?: string;
  subtitle?: string;
  loader: any;
  isPortal?: boolean
}) => {
  return (
    <div>
      {title && (
        <Typography.Title style={{ fontSize: 20 }}>{title}</Typography.Title>
      )}
      {subtitle && (
        <Typography.Title style={{ fontSize: 16, marginBottom: 20 }}>
          {subtitle}
        </Typography.Title>
      )}
      <DisplayForm
        formSectionList={data}
        translate={translate}
        isEditableForm={false}
        isPreviousForm={true}
        isDraftFormVersion={() => false}
        className={"display-form-report-1"}
        loading={loader}
        pdfReportVisible={true}
        generatePdfReport={() => {}}
        allowedFileTypes=""
        isPortal={isPortal}
      />
    </div>
  );
};

export default Report1Preview;
